@if (offer(); as o) {
	@if (form) {
		<div class="u-card u-card--float">
			<p class="u-text--grey-blue u-m-bottom--sm">{{ 'BOOKING.INFO_OPTIONALS' | translate }}</p>

			<tvcore-message color="orange" icon="warning" class="u-m-bottom--md">
				<p class="u-text--bold u-m-bottom--xxs">{{ 'GROUPS_BOOKING.WARNING.TITLE' | translate }}</p>
				<p [innerHTML]="(o.type === OffersType.ACCOMMODATION ? 'GROUPS_BOOKING.WARNING.MESSAGE_ACCOMMODATION' : 'GROUPS_BOOKING.WARNING.MESSAGE') | translate"></p>
			</tvcore-message>

			<form [formGroup]="form">
				<ng-container formGroupName="socialOrganization">
					<p class="u-title-sub u-m-bottom--xs">{{ 'GROUPS_BOOKING.SOCIAL_ORG.TITLE' | translate }}</p>

					<div class="u-row">
						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'GROUPS_BOOKING.SOCIAL_ORG.NAME' | translate" name="name" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>
					</div>

					<div class="u-row">
						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'GROUPS_BOOKING.SOCIAL_ORG.ADDRESS' | translate" name="address" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>
					</div>

					<div class="u-row">
						<tvcore-input class="u-col-sm--12 u-col--2" [label]="'GROUPS_BOOKING.SOCIAL_ORG.POSTAL_CODE' | translate" name="postalCode" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>

						<tvcore-input class="u-col-sm--12 u-col--4" [label]="'GROUPS_BOOKING.SOCIAL_ORG.CITY' | translate" name="city" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>
					</div>
				</ng-container>

				<ng-container formGroupName="booker">
					<p class="u-title-sub u-m-top--md u-m-bottom--xs">{{ 'GROUPS_BOOKING.MAIN_CONTACT' | translate }}</p>

					<div class="u-row">
						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.FIRSTNAME' | translate" name="firstName" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>

						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.LASTNAME' | translate" name="lastName" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>
					</div>

					<div class="u-row">
						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'BOOKING.DETAILS.EMAIL' | translate" name="email" type="email" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
							<tvcore-input-error name="pattern">{{ 'FORM.ERROR.EMAIL_INVALID' | translate }}</tvcore-input-error>
						</tvcore-input>

						<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.PHONE' | translate" name="phone" type="tel" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
							<tvcore-input-error name="format">{{ 'FORM.ERROR.PHONE_INVALID' | translate }}</tvcore-input-error>
						</tvcore-input>
					</div>
				</ng-container>

				<p class="u-title-sub u-m-top--md u-m-bottom--xs">{{ 'GROUPS_BOOKING.CONTACTS.TITLE' | translate }}</p>
				<p class="u-m-bottom--sm">{{ 'GROUPS_BOOKING.CONTACTS.DESCRIPTION' | translate }}</p>

				<div formArrayName="other">
					@for (group of other.controls; track group) {
						<div class="c-contact u-m-bottom--sm" [formGroupName]="$index">
							<div class="u-row">
								<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.FULL_NAME' | translate" name="fullName" [showErrors]="showErrors">
									<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
								</tvcore-input>

								<tvcore-input class="u-col-sm--12 u-col--6" [label]="'BOOKING.DETAILS.EMAIL' | translate" name="email" type="email" [showErrors]="showErrors">
									<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
									<tvcore-input-error name="pattern">{{ 'FORM.ERROR.EMAIL_INVALID' | translate }}</tvcore-input-error>
								</tvcore-input>
							</div>

							<button class="c-btn-link c-btn--with-icon" (click)="removeContact($index)" type="button">
								<tvcore-icon name="trash"></tvcore-icon>
								{{ 'GROUPS_BOOKING.CONTACTS.REMOVE_BUTTON' | translate }}
							</button>
						</div>
					}

					<button class="c-btn-link c-btn--with-icon" (click)="addContact()" type="button">
						<tvcore-icon name="plus"></tvcore-icon>
						{{ 'GROUPS_BOOKING.CONTACTS.ADD_BUTTON' | translate }}
					</button>
				</div>

				@if (o.type === OffersType.DAYTRIP) {
					<p class="u-title-sub u-m-top--md">{{ 'GROUPS_BOOKING.DAYTRIP.TITLE' | translate }}</p>
					<p class="u-text--grey-blue u-m-bottom--sm" [innerHTML]="'GROUPS_BOOKING.DAYTRIP.DESCRIPTION' | translate"></p>

					<div class="u-row">
						<tvcore-datepicker class="u-col-sm--12 u-col--3" [label]="'GROUPS_BOOKING.DAYTRIP.ARRIVAL_DATE' | translate" name="arrivalDate" icon="date" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
							<tvcore-input-error name="dateAfter">{{ 'BOOKING.INFO.DATE_AFTER_TODAY_ERROR' | translate }}</tvcore-input-error>
						</tvcore-datepicker>

						<tvcore-dropdown
							class="u-col-sm--12 u-col--3"
							[label]="'GROUPS_BOOKING.DAYTRIP.ARRIVAL_HOUR' | translate"
							name="arrivalHour"
							[options]="hourOptions"
							[showErrors]="showErrors"
						>
							<ng-template #optionTemplate let-option>{{ option }}</ng-template>
						</tvcore-dropdown>
					</div>
				} @else if (o.type === OffersType.ACCOMMODATION) {
					<p class="u-title-sub u-m-top--md">{{ 'GROUPS_BOOKING.ACCOMMODATION.TITLE' | translate }}</p>
					<p class="u-text--grey-blue u-m-bottom--sm" [innerHTML]="'GROUPS_BOOKING.ACCOMMODATION.DESCRIPTION' | translate"></p>

					<div class="u-row">
						<tvcore-datepicker
							class="u-col-sm--12 u-col--3"
							[label]="'GROUPS_BOOKING.ACCOMMODATION.ARRIVAL_DATE' | translate"
							name="arrivalDate"
							icon="date"
							[showErrors]="showErrors"
						>
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
							<tvcore-input-error name="dateAfter">{{ 'BOOKING.INFO.DATE_AFTER_TODAY_ERROR' | translate }}</tvcore-input-error>
						</tvcore-datepicker>

						<tvcore-datepicker
							class="u-col-sm--12 u-col--3"
							[label]="'GROUPS_BOOKING.ACCOMMODATION.DEPARTURE_DATE' | translate"
							name="departureDate"
							icon="date"
							[showErrors]="showErrors"
						>
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
							<tvcore-input-error name="dateAfter">{{ 'BOOKING.INFO.DATE_AFTER_TODAY_ERROR' | translate }}</tvcore-input-error>
							<tvcore-input-error name="after">{{ 'BOOKING.INFO.DATE_AFTER_ARRIVAL_ERROR' | translate }}</tvcore-input-error>
						</tvcore-datepicker>
					</div>

					<div class="u-row">
						<tvcore-dropdown
							class="u-col-sm--12 u-col--3"
							[label]="'GROUPS_BOOKING.ACCOMMODATION.ARRIVAL_HOUR' | translate"
							name="arrivalHour"
							[options]="hourOptions"
							[showErrors]="showErrors"
						>
							<ng-template #optionTemplate let-option>{{ option }}</ng-template>
						</tvcore-dropdown>
					</div>
				}

				<p class="u-title-sub u-m-top--md u-m-bottom--xs">{{ 'GROUPS_BOOKING.PARTICIPANTS.TITLE' | translate }}</p>
				<p class="u-m-bottom--sm">{{ 'GROUPS_BOOKING.PARTICIPANTS.DESCRIPTION' | translate }}</p>

				<p class="u-text--medium u-m-bottom--tiny">{{ 'GROUPS_BOOKING.PARTICIPANTS.AMOUNT' | translate }}</p>
				<p class="u-text--sm u-text--grey-blue u-m-bottom--tiny">{{ 'GROUPS_BOOKING.PARTICIPANTS.AMOUNT_DESCRIPTION' | translate }}</p>

				<div class="u-row">
					<tvcore-input class="u-col-sm--12 u-col--3" name="participants" type="number" [showErrors]="showErrors">
						<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						<tvcore-input-error name="min">{{ 'FORM.ERROR.MORE_OR_EQUAL' | translate: { min: MIN_PARTICIPANTS } }}</tvcore-input-error>
					</tvcore-input>
				</div>

				<div class="u-row">
					<div class="u-col--12">
						<p class="u-text--medium">
							{{ 'GROUPS_BOOKING.EXTRA_INFO.TITLE' | translate }}
							<span class="u-text--sm u-text--grey-blue u-text--normal">(optioneel)</span>
						</p>
						<p class="u-text--grey-blue">{{ 'GROUPS_BOOKING.EXTRA_INFO.DESCRIPTION' | translate }}</p>

						@if (o.type === OffersType.DAYTRIP) {
							<p class="u-text--grey-blue">
								Als er deelnemers onder de 18 jaar meegaan; vermeld dan hier hoeveel deelnemers van welke leeftijd. Enkel als dit voor deze daguitstap impact heeft op de prijs.
							</p>
						}

						<tvcore-input name="extraInfo" type="textarea" [maxChar]="MAX_CHARS_INFO" [showErrors]="showErrors"></tvcore-input>
					</div>
				</div>

				<div class="u-m-top--sm u-m-bottom--sm">
					<tvcore-checkbox class="u-width--md" name="confirmThreshold" [showErrors]="showErrors">
						@if (o.type === OffersType.DAYTRIP) {
							<span [innerHTML]="'GROUPS_BOOKING.THRESHOLD_DAYTRIP' | translate"></span>
						} @else if (o.type === OffersType.ACCOMMODATION) {
							<span [innerHTML]="'GROUPS_BOOKING.THRESHOLD_ACCOMMODATION' | translate"></span>
						}
					</tvcore-checkbox>
					<p *ngIf="confirmThresholdError" class="u-text--error u-text--sm">{{ 'FORM.ERROR.REQUIRED' | translate }}</p>
				</div>
			</form>

			<hr class="u-m-top--md u-m-bottom--md" />

			<div class="flex-row flex--space flex-gap--xs">
				<div></div>

				<button class="c-btn" (click)="submit()" type="submit" [disabled]="loadingSubmit()">
					{{ loadingSubmit() ? 'Bezig met verzenden...' : ((o.type === OffersType.ACCOMMODATION ? 'BOOKING.SUBMIT_BUTTON_ACCOMMODATION' : 'BOOKING.SUBMIT_BUTTON') | translate) }}
				</button>
			</div>
		</div>
	}
}
